import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './ModalLink.scss';
const ModalLink = (props)=>/*#__PURE__*/ React.createElement(BiLink, _object_spread({
        className: s['root']
    }, props));
ModalLink.displayName = 'ModalLink';
export default ModalLink;
